import { enUS, uk, ru, es, pl, fr, it, de, pt, tr, vi } from 'date-fns/locale';
import type { Locale } from 'date-fns';

export const DATE_FNS_LOCALES: Record<string, Locale> = {
  en: enUS,
  uk: uk,
  ru: ru,
  es: es,
  'es-419': es,
  pl: pl,
  fr: fr,
  it: it,
  de: de,
  pt: pt,
  tr: tr,
  vi: vi,
};

/**
 * Safe getter with fallback
 */
export function getDateFnsLocale(lang?: string): Locale {
  return DATE_FNS_LOCALES[lang ?? 'en'] ?? enUS;
}
